import { useState } from 'react';
import { useMountEffect } from 'primereact/hooks';
import apiClient from '../../../services/api-client';
import StorageHelper from '../../../utils/storage-helper';

/**
 * Loads the signed-in user's tracked policies once and keeps the element to display.
 *
 * `renderResponse(apiResponse, policyDisplayKey, { updateSelectedPolicy })` turns the track response into
 * the element to show; it is called again when the user picks another policy from the list.
 */
export const usePolicyTracking = (renderResponse) => {
    const [policyDisplay, setPolicyDisplay] = useState(null);
    const [loading, setLoading] = useState(true);

    const show = (apiResponse, policyDisplayKey) => {
        setLoading(false);
        setPolicyDisplay(renderResponse(apiResponse, policyDisplayKey, { updateSelectedPolicy }));
    };

    function updateSelectedPolicy(policyValue, policyList, apiResponse) {
        const policyDisplayKey = policyList.findIndex(
            (item) => item.MainMember.Policy_Number === policyValue.MainMember.Policy_Number
        );
        show(apiResponse, policyDisplayKey);
    }

    useMountEffect(() => {
        const getPolicyDetails = async () => {
            setLoading(true);
            try {
                const userProfile = StorageHelper.get('userProfile');
                const response = await apiClient.get('policy/track/' + userProfile.idnumber);
                show(response.data, 0);
            } catch (error) {
                setLoading(false);
                console.error('Error fetching balance details:', error);
            }
        };
        getPolicyDetails();
    });

    return { policyDisplay, loading };
};
